import Area from "../components/Security/Area/Area";

const Interface = () => {

    return <Area />;

}

export default Interface;